function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_4960",
  "data-name": "Rectangle 4960",
  d: "M0,0H32V32H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_29524",
  "data-name": "Path 29524",
  d: "M61.937,277.539l2.768,2.755a1,1,0,0,1-.509,1.689l-3.692.739a1,1,0,0,0-.785.784l-.738,3.693a1,1,0,0,1-1.688.511l-4.355-4.355,1.076-.6,1.773-.022a3,3,0,0,0,2.542-1.468l.906-1.524,1.524-.906a2.992,2.992,0,0,0,1.178-1.3Zm-21.879-.009a3,3,0,0,0,1.183,1.3l1.524.906.906,1.524a3,3,0,0,0,2.542,1.468l1.773.022,1.076.6L44.707,287.7a1,1,0,0,1-1.688-.511l-.738-3.693a1,1,0,0,0-.785-.784l-3.692-.739a1,1,0,0,1-.511-1.687Zm8.462-15.283,1.991-1.116a1,1,0,0,1,.978,0l1.991,1.116,2.282.029a1,1,0,0,1,.848.489l1.165,1.962,1.963,1.166a1,1,0,0,1,.489.847l.028,2.283,1.117,1.99a1,1,0,0,1,0,.979l-1.117,1.991-.028,2.282a1,1,0,0,1-.489.847l-1.963,1.166-1.165,1.963a1,1,0,0,1-.848.489l-2.282.028-1.991,1.117a1,1,0,0,1-.978,0l-1.991-1.117-2.282-.028a1,1,0,0,1-.848-.489l-1.165-1.963-1.963-1.166a1,1,0,0,1-.489-.847l-.028-2.282-1.117-1.991a1,1,0,0,1,0-.979l1.117-1.99.028-2.283a1,1,0,0,1,.489-.847l1.963-1.166,1.165-1.962a1,1,0,0,1,.848-.489Zm.34,6.274,1.256-2.38a1,1,0,0,1,1.768,0l1.256,2.38,2.652.459a1,1,0,0,1,.547,1.682l-1.876,1.93.383,2.664a1,1,0,0,1-1.431,1.039L51,275.108,48.585,276.3a1,1,0,0,1-1.431-1.039l.383-2.664-1.876-1.93a1,1,0,0,1,.547-1.682Z",
  transform: "translate(-35 -258.003)",
  fill: "#03001e",
  fillRule: "evenodd"
});

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "medal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.5992485c.svg";
export { ForwardRef as ReactComponent };